declare global {
  interface Window {
    __APPIC_UI_RUNTIME_INITIALIZED__?: boolean;
  }
}

export type ThemeKey = 'light' | 'dark' | 'high-contrast' | string;

function detectThemeFromUrl(): ThemeKey | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const url = new URL(window.location.href);
    const fromParam = url.searchParams.get('theme');
    return (fromParam as ThemeKey) ?? undefined;
  } catch {
    return undefined;
  }
}

export function applyTheme(theme: ThemeKey): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = theme;
}

export function validateTheme(_theme: ThemeKey): void {
  if (typeof document === 'undefined') return;
  // Placeholder for future schema-based validation or logging.
}

export function initUiRuntime(options?: { theme?: ThemeKey }): void {
  if (typeof window === 'undefined') return;
  if (window.__APPIC_UI_RUNTIME_INITIALIZED__) return;

  window.__APPIC_UI_RUNTIME_INITIALIZED__ = true;

  const theme = options?.theme ?? detectThemeFromUrl() ?? 'dark';
  applyTheme(theme);
  validateTheme(theme);
}

// Debug overlay (component badges). Provider no-ops in production (NODE_ENV guard inside).
export { DebugOverlayProvider, useDebugOverlay, DebugBadge } from './debug';
export type { DebugBadgeProps } from './debug';

